
const SolutionsSection = () => {
  const solutions = [
    {
      number: '01',
      title: 'Gestion de la Relation Client',
      description: 'Optimisez votre suivi client avec des outils simples et efficaces. Gérez vos devis, factures et relances automatiquement, tout en gardant une trace de chaque échange. Concentrez-vous sur votre métier pendant que nous facilitons votre relation client.',
      benefits: [
        'CRM adapté aux artisans',
        'Suivi automatisé des devis',
        'Relances clients intelligentes',
        'Historique centralisé',
      ],
      image: 'https://public.readdy.ai/ai/img_res/8493fd39094586237a89218d7c0ee1ad.jpg',
    },
    {
      number: '02',
      title: 'Outils Administratifs & Comptabilité',
      description: 'Simplifiez votre gestion administrative avec des solutions intuitives. De la facturation à la comptabilité, en passant par les déclarations obligatoires, bénéficiez d\'outils qui vous font gagner un temps précieux et réduisent les erreurs.',
      benefits: [
        'Facturation automatisée',
        'Comptabilité simplifiée',
        'Déclarations facilitées',
        'Tableaux de bord clairs',
      ],
      image: 'https://readdy.ai/api/search-image?query=Organized%20artisan%20office%20desk%20with%20laptop%20showing%20business%20management%20software%2C%20invoices%20and%20administrative%20documents%20neatly%20arranged%2C%20modern%20professional%20workspace%2C%20bright%20natural%20lighting%2C%20clean%20and%20efficient%20work%20environment%20photography&width=800&height=600&seq=artisan-admin-001&orientation=landscape',
    },
    {
      number: '03',
      title: 'Référencement Local & Visibilité',
      description: 'Développez votre présence en ligne et attirez de nouveaux clients dans votre zone d\'intervention. Optimisez votre visibilité sur Google, les réseaux sociaux et les plateformes spécialisées pour être trouvé facilement par vos futurs clients.',
      benefits: [
        'Optimisation Google My Business',
        'Présence réseaux sociaux',
        'Avis clients gérés',
        'Site web professionnel',
      ],
      image: 'https://readdy.ai/api/search-image?query=Smartphone%20and%20laptop%20displaying%20artisan%20business%20website%20and%20social%20media%20profiles%20with%20five%20star%20reviews%2C%20digital%20marketing%20for%20local%20craftsmen%2C%20modern%20online%20presence%2C%20professional%20web%20design%20showcase%2C%20bright%20clean%20photography&width=800&height=600&seq=artisan-seo-001&orientation=landscape',
    },
    {
      number: '04',
      title: 'Formation & Montée en Compétences',
      description: 'Restez à jour avec les dernières techniques et normes de votre métier. Accédez à des formations pratiques, adaptées à votre emploi du temps, pour développer vos compétences techniques et commerciales.',
      benefits: [
        'Formations métier certifiantes',
        'Veille réglementaire',
        'Techniques innovantes',
        'Gestion d\'entreprise',
      ],
      image: 'https://readdy.ai/api/search-image?query=Artisan%20attending%20professional%20training%20workshop%2C%20hands-on%20learning%20session%20with%20instructor%20demonstrating%20new%20techniques%2C%20modern%20training%20facility%20with%20professional%20equipment%2C%20collaborative%20learning%20environment%2C%20high%20quality%20educational%20photography&width=800&height=600&seq=artisan-formation-001&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-light/5">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary-dark mb-3 md:mb-4">
            Nos Solutions pour les Artisans
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-dark max-w-2xl mx-auto">
            Des outils et services pensés pour faciliter votre quotidien professionnel
          </p>
        </div>

        <div className="space-y-16 md:space-y-24">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="relative">
                  <div className="absolute -top-6 -left-6 md:-top-8 md:-left-8 text-6xl md:text-8xl font-bold text-primary-light/20 select-none">
                    {solution.number}
                  </div>
                  <div className="relative space-y-4 md:space-y-6">
                    <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-primary-dark">
                      {solution.title}
                    </h3>
                    <p className="text-sm md:text-base lg:text-lg text-gray-dark leading-relaxed">
                      {solution.description}
                    </p>
                    <ul className="space-y-2 md:space-y-3">
                      {solution.benefits.map((benefit, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center bg-primary rounded-full flex-shrink-0 mt-0.5">
                            <i className="ri-check-line text-white text-xs"></i>
                          </div>
                          <span className="text-sm md:text-base text-gray-dark">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
